import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './components/css/theme.css';
import './components/css/animations.css';
import AppRoutes from './components/Routes';
import IconGradients from './components/js/common/IconGradients';
import ScrollToTop from './components/js/common/ScrollToTop';
import SmoothScroll from './components/js/common/SmoothScroll';
import RevealOnScroll from './components/js/common/RevealOnScroll';

function App() {
  return (
    <div className="App">
      <SmoothScroll />
      <ScrollToTop />
      <RevealOnScroll />
      <IconGradients />
      <AppRoutes />
    </div>
  );
}

export default App;
